import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mainApi } from "../../api/axios";

/**
 * Get order history
 */
export const getOrderHistory = createAsyncThunk(
  "orderHistory/getOrderHistory",
  async ({ storeId, startDate, endDate }, { rejectWithValue }) => {
    try {
      const res = await mainApi.get(
        `/v1/pos/report/sales/orders/date-wise-summary?store_id=${storeId}&start_date=${startDate}&end_date=${endDate}`,
      );
      return res.data || {};
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

// Slice
const orderHistorySlice = createSlice({
  name: "history",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get History
      .addCase(getOrderHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrderHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(getOrderHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {} = orderHistorySlice.actions;
export default orderHistorySlice.reducer;
